import { render, staticRenderFns } from "./ClaimsHeader.vue?vue&type=template&id=3911ab41&"
import script from "./ClaimsHeader.vue?vue&type=script&lang=js&"
export * from "./ClaimsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports